"use client"

import { Button } from "@/components/ui/button"
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import { X } from "lucide-react"
import { useState } from "react"
import { FilterSection, type FilterState } from "./filter-section"

interface MobileFilterDrawerProps {
  loading?: boolean
  onFilterChange?: (filters: FilterState) => void
  initialFilters?: FilterState
  children?: React.ReactNode
  data?: any
}

export function MobileFilterDrawer({
  // filters,
  onFilterChange,
  initialFilters = {},
  children,
  data,
}: MobileFilterDrawerProps) {
  const [open, setOpen] = useState(false)
  // const [localFilters, setLocalFilters] = useState<FilterState>(initialFilters)

  // Update local filters when initialFilters change (from URL)
  // useEffect(() => {
  //   if (Object.keys(initialFilters).length > 0) {
  //     setLocalFilters(initialFilters)
  //   }
  // }, [initialFilters])

  // const handleApplyFilters = () => {
  //   onFilterChange?.(localFilters)
  //   setOpen(false)
  // }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent className="h-[60vh] p-0 m-0 w-full">
        <DrawerHeader className="flex sr-only justify-between items-center border-b pb-4">
          <DrawerTitle>Filters</DrawerTitle>
          <DrawerClose asChild>
            <Button variant="ghost" size="icon">
              <X className="h-4 w-4" />
            </Button>
          </DrawerClose>
        </DrawerHeader>
        <div className="px-4 py-2 overflow-y-auto flex-1">
          <FilterSection
            data={data}
            initialFilters={initialFilters}
            onFilterChange={onFilterChange}
          />
        </div>
        <DrawerFooter className="sr-only border-t pt-4">
          {/* <Button onClick={handleApplyFilters}>Apply Filters</Button> */}
          <DrawerClose asChild>
            <Button variant="outline">Cancel</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}
